import { CatHeading } from '@blocks-react/components/Heading';
import { ReactElement } from 'react';

export interface EquipmentActionNameProps {
  children: ReactElement | ReactElement[] | string;
}

export const EquipmentActionName = ({ children }: EquipmentActionNameProps) => {
  return <CatHeading variant="label-sm">{children}</CatHeading>;
};

export default EquipmentActionName;
